// Cosmetic reflection of entitlement for a specific exam. The real gate is
// server-side in generateQuestions — this banner only explains why generation is
// locked and routes to Checkout for THIS exam. A user who bypasses it still
// cannot generate: the function refuses an unentitled (uid, examId).

import { useState } from 'react';
import { createCheckoutSession } from '../lib/functions';

export default function PaywallBanner({ examId, examName }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  async function subscribe() {
    if (!examId) return;
    setBusy(true);
    setErr(null);
    try {
      const url = await createCheckoutSession(examId);
      window.location.assign(url);
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'Could not start checkout.');
      setBusy(false);
    }
  }

  return (
    <div className="paywall">
      <span className="lock">● Locked</span>
      <div style={{ flex: 1, minWidth: 200 }}>
        <strong>{examName ? `${examName} is a subscriber feature.` : 'Generation is a subscriber feature.'}</strong>
        <div className="muted" style={{ fontSize: '0.85rem' }}>
          Subscribe to this exam to generate blueprint-tailored questions from the validated corpus.
        </div>
      </div>
      <button className="btn btn-primary" onClick={subscribe} disabled={busy || !examId}>
        {busy ? 'Starting…' : 'Subscribe'}
      </button>
      {err && (
        <div className="error-note" style={{ flexBasis: '100%' }}>
          {err}
        </div>
      )}
    </div>
  );
}
